import { POST } from '@wellsfargo/ecpfs-authority'

export const ATTORNEY_TERMS_OF_USE_PATH = 'login/footer/eau/toc/tocText.json'

export function fetchAttorneyTermsOfUse() {
	return POST(ATTORNEY_TERMS_OF_USE_PATH, {})
}
